<template>
    <pop :showMask="false" :allowClose="false">
        <div :class="`comp-gallery-pop pc ${theme}`" ref="galleryPopRef">
            <div class="com-gallery-pop_inner">
                <!-- tab -->
                <div class="inner-header">
                    <div class="inner-tab">
                        <template v-for="(item, index) in tabs">
                            <p
                                v-if="showCurrentTab(item)"
                                :key="'tab-' + item.name"
                                :class="{ active: selectedTabIndex === index }"
                                @click="handleChangeTabs(item, index)"
                            >
                                {{ item.name }}
                            </p>
                        </template>
                    </div>
                    <p
                        class="img-number"
                        v-if="
                            selectedTabIndex == 0 &&
                                getSourceList &&
                                getSourceList.length
                        "
                    >
                        <span>{{ currentMediaTabIndex + 1 }}</span> /
                        {{ getSourceList.length }}
                    </p>
                    <!-- status -->
                    <div class="inner-status">
                        <div
                            v-if="!sold"
                            class="pop-icons save"
                            @click="onFavoriteClick"
                            :class="hasFavor ? 'active' : ''"
                        >
                            <i class="iconfont icon-heart default"></i>
                            <i class="iconfont icon-heart-fill hover"></i>
                            <span class="btn-text">{{
                                $t('md-detail-info.save')
                            }}</span>
                        </div>
                        <div class="pop-icons share">
                            <i
                                class="iconfont icon-v2-share-Normal default"
                            ></i>
                            <!-- hover share icon -->
                            <i class="iconfont icon-v2-share-hover hover"></i>
                            <span class="btn-text">{{
                                $t('md-detail-info.share')
                            }}</span>
                            <share-popper
                                class="popper"
                                :shares="shares"
                                :theme="theme"
                                :listingId="info.id"
                            ></share-popper>
                        </div>
                        <div class="pop-icons request" v-if="sold">
                            <span @click="request">{{
                                $t('md-detail-info.requestAFreeAnalysis')
                            }}</span>
                        </div>
                        <div class="pop-icons">
                            <i
                                class="iconfont icon-close-light"
                                @click="closeInnerPop"
                            ></i>
                        </div>
                    </div>
                </div>

                <!-- content -->
                <div class="inner-content">
                    <div class="img-tabs" v-if="selectedTabIndex == 0">
                        <template v-for="(item, index) in getSourceList">
                            <template v-if="['img'].includes(item.type)">
                                <img-box
                                    :class="[
                                        {
                                            'img-row-box':
                                                item.preview !=
                                                allImgs[0].preview
                                        },
                                        {
                                            active:
                                                currentMediaTabIndex == index
                                        }
                                    ]"
                                    :src="item.preview"
                                    :key="index"
                                    :lazy="true"
                                    alt
                                    @click="streamToInner(item, index)"
                                ></img-box>
                            </template>

                            <div
                                v-else
                                :key="index"
                                class="video-preview"
                                :class="[
                                    { active: currentMediaTabIndex == index },
                                    { 'my-video': item.type == 'video' },
                                    {
                                        'my-virtural':
                                            item.type == 'virtualTour'
                                    }
                                ]"
                                @click="streamToInner(item, index)"
                            >
                                <site-img :src="item.preview"></site-img>
                                <div class="play-icon">
                                    <i class="iconfont icon-arrow_04_down"></i>
                                </div>
                            </div>
                        </template>
                    </div>
                    <div class="content">
                        <div
                            class="mls-info"
                            v-if="companyName || listingId || infoLogo"
                        >
                            <site-img
                                :src="infoLogo"
                                class="mls-info-logo"
                            ></site-img>
                            <span class="mls-info-companyname">{{
                                companyName
                            }}</span>
                            <span
                                class="mls-info-split"
                                v-if="companyName && listingId"
                            ></span>
                            <span class="mls-info-mlslistingid">{{
                                listingId
                            }}</span>
                        </div>
                        <div
                            class="my-swiper-box"
                            id="my-swiper-box"
                            ref="myWriperBoxRef"
                        >
                            <template v-for="(tab, index) in tabs">
                                <swiper
                                    :key="index"
                                    v-bind="swiperOptions"
                                    v-if="
                                        selectedTabIndex === index &&
                                            showCurrentTab(tab)
                                    "
                                    @init="onSwiperReady"
                                    @slideChange="slideChange"
                                >
                                    <slide
                                        v-for="(item, i) in getSourceList"
                                        :key="item.preview + i"
                                        class="slide-content swiper-no-swiping"
                                    >
                                        <div
                                            v-if="selectedTabIndex === 0"
                                            class="gallery-img"
                                            :ref="'galleryImgRef' + i"
                                            :class="[
                                                {
                                                    'my-video-img-box':
                                                        item.type === 'video'
                                                },
                                                {
                                                    'my-3d-img-box':
                                                        item.type === '3d'
                                                },
                                                {
                                                    'my-virtual-img-box':
                                                        item.type ===
                                                        'virtualTour'
                                                }
                                            ]"
                                            @click="changeToVideo(item)"
                                        >
                                            <site-img
                                                :src="item.preview"
                                                dir="height"
                                                :ref="'imgRef' + i"
                                                :style="{
                                                    height: getScaleValue + '%'
                                                }"
                                                @mousedown="
                                                    posMove(
                                                        $event,
                                                        item.type,
                                                        i
                                                    )
                                                "
                                            ></site-img>
                                            <div
                                                class="play-icon"
                                                v-if="
                                                    item.type === 'video' ||
                                                        item.type === 'virtualTour'
                                                "
                                            >
                                                <i
                                                    class="iconfont icon-arrow_04_down"
                                                ></i>
                                            </div>
                                        </div>

                                        <div
                                            v-else-if="
                                                [
                                                    '3d',
                                                    'virtualTour',
                                                    'video'
                                                ].includes(item.type)
                                            "
                                            class="video-content"
                                        >
                                            <!--  can be used video use video -->
                                            <video
                                                v-if="
                                                    canPlayWithVideo(item.url)
                                                "
                                                :src="item.url"
                                                controls="controls"
                                            ></video>
                                            <iframe
                                                v-else
                                                :style="iframeStyle"
                                                frameborder="no"
                                                :src="formatUrl(item.url)"
                                                allow="autoplay; fullscreen"
                                            ></iframe>
                                        </div>
                                    </slide>
                                    <div
                                        class="swiper-button-prev iconfont icon-prev"
                                    ></div>
                                    <div
                                        class="swiper-button-next iconfont icon-next"
                                    ></div>
                                </swiper>
                            </template>
                            <div
                                class="rangeBox"
                                v-if="
                                    selectedTabIndex == 0 &&
                                        getSourceList[currentMediaTabIndex].type ===
                                        'img'
                                "
                            >
                                <span @click="handleReduce">—</span>
                                <my-slider
                                    class="mySlider"
                                    :min="50"
                                    :max="200"
                                    :step="1"
                                    :format-tooltip="formatTooltip"
                                    v-model="scaleValue"
                                ></my-slider>
                                <span @click="handleRelarge">+</span>
                            </div>
                        </div>
                        <button @click="schedulePop" v-if="!sold" class="schedule-bth">
                            {{ $t('md-detail-info.scheduleATour') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </pop>
</template>

<script>
import { mapState as rootMapState } from 'pinia';
import { mapState } from '@/store/helpers';
import { useUserStore, usePageStore } from '@/store';
import mySlider from '@/components/slider';
import util from '@/common/util';
import SharePopper from './share-popper.vue';
import { Swiper, SwiperSlide, fixSwiperOptions } from '@/common/swiper';
import signLog from '@/components/sign-log';
import API from './api.js';
function getMatterPort(links = [], type = '3d') {
    let reg = /matterport\.(com|cn)\/show/;
    let matterPortLink = links.find(l => reg.test(l));
    if (!matterPortLink) {
        return false; 
    }
    return {
        type,
        url: matterPortLink,
        preview:
            '//cdn.chime.me/image/fs/sitebuild/site-cms/listing-detail/3d.jpeg'
    };
}
export default {
    emits: ['share'],
    i18next: {
        ns: 'md-detail-info'
    },
    data: function() {
        return {
            DEFAULT_IMAGE:
                '//fs01.chime.me/image/fs/sitebuild/2021224/20/original_ddff9285-b8a4-4fd5-840f-0233eb9cc979.png',
            selectedTabIndex: 0,
            source: {
                imgs: [],
                virtuals: [],
                videos: []
            },
            currentMediaTabIndex: 0,
            scaleValue: 100,
            defaultScaleValue: 100,
            swiper: null
        };
    },
    components: {
        Swiper,
        Slide: SwiperSlide,
        SharePopper,
        mySlider
    },
    computed: {
        ...rootMapState(usePageStore, {
            'page': store => store.page || {},
            'siteId': 'siteId'
        }),
        ...rootMapState(useUserStore, {
            'user': store => store.user
        }),
        ...mapState({
            'hasFavor': store => store.hasFavor
        }),
        infoLogo() {
            return this.info?.mlsOrg?.logo;
        },
        companyName() {
            return this.info?.agentOrganizationName;
        },
        listingId() {
            return this.info?.mlsListingId;
        },
        allImgs() {
            return this.source?.imgs?.filter(v => v.type === 'img') || [];
        },
        info() {
            return this.listingDetail.info || {};
        },
        iframeStyle() {
            return 'width: 100%; height: 100%';
        },
        getSourceList() {
            let surceList = [];
            if (this.selectedTabIndex == 1) {
                surceList = this.source?.virtuals;
            } else if (this.selectedTabIndex == 2) {
                surceList = this.source?.videos;
            } else {
                surceList = this.source?.imgs;
            }
            return surceList;
        },
        getScaleValue() {
            return this.scaleValue;
        },
        tabs() {
            return [
                { name: this.$t('md-detail-info.photos'), value: 'imgs' },
                {
                    name: this.$t('md-detail-info.virtualTour'),
                    value: 'virtuals'
                },
                { name: this.$t('md-detail-info.videoTour'), value: 'videos' }
            ];
        }
    },
    props: {
        onFavoriteClick: {},
        shares: {
            type: Object
        },
        listingDetail: {
            type: Object,
            required: true
        },
        sold: {
            type: Boolean,
            default: false
        },
        theme: {
            type: String,
            default: 'classic'
        },
        schedulePop: { type: Function }
    },
    created() {
        this.initGalleryData();
        this.swiperOptions = fixSwiperOptions({
            navigation: {
                closest: '.my-swiper-box',
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
                disabledClass: 'disabled'
            }
        });
    },
    beforeMount() {
        this.fingerPs = Promise.all([
            util.addScript(
                '//static.chimeroi.com/servicetool-temp/AlloyFinger.js'
            ),
            util.addScript(
                '//static.chimeroi.com/servicetool-temp/transform.js'
            )
        ]);
        // window.addEventListener('keyup', this.onKeyUp, false);
    },
    unmounted() {
        // window.removeEventListener('keyup', this.onKeyUp, false);
    },
    methods: {
        onSwiperReady(swiper) {
            this.swiper = swiper;
            this.swiper.slideTo(this.currentMediaTabIndex);
        },
        slideChange(swiper) {
            this.currentMediaTabIndex = swiper.activeIndex;
        },
        /**
         * type
         * photo -> img
         * virtuals -> 3d,virtualTour
         * videos-> video
         */
        initGalleryData: function() {
            let listingPictures = !this.info.listingPictures
                ? []
                : this.info.listingPictures.split('|').filter(item => !!item);
            this.source.imgs = listingPictures.map(url => {
                return {
                    preview: url,
                    type: 'img',
                    url
                };
            });

            let { link, chimeVideoLink } = this.info;

            let virtualLinks = link ? link.split(' ') : [],
                videoLinks = chimeVideoLink ? chimeVideoLink.split(' ') : [];

            let placeImageIndex = 0;
            if (virtualLinks.length > 0) {
                let virtualMatterport = getMatterPort([...virtualLinks], '3d');
                if (virtualMatterport) {
                    this.source.virtuals.push(virtualMatterport);
                } else {
                    this.source.virtuals.push({
                        preview:
                            listingPictures[placeImageIndex++] ||
                            this.DEFAULT_IMAGE,
                        type: 'virtualTour',
                        url: virtualLinks[0]
                    });
                }
            }
            if (videoLinks.length > 0) {
                let videoMatterport = getMatterPort([...videoLinks], '3d');
                if (videoMatterport) {
                    this.source.videos.push(videoMatterport);
                } else {
                    this.source.videos.push({
                        preview:
                            listingPictures[placeImageIndex++] ||
                            this.DEFAULT_IMAGE,
                        type: 'video',
                        url: videoLinks[0]
                    });
                }
            }

            if (this.source.imgs.length === 0) {
                this.source.imgs.push({
                    preview: this.DEFAULT_IMAGE,
                    type: 'img'
                });
            }
            let arr = this.source.imgs.filter(v => v.type === 'img') || [];
            let virtuals = this.source.virtuals || [];
            let videos = this.source.videos || [];
            // type=3d may be virtualTour it may also be videoTour, also possible 2 both have ，type=3d in second place
            if (arr.length >= 1) {
                if (
                    virtuals.length > 0 &&
                    virtuals[0].type !== '3d' &&
                    videos.length > 0 &&
                    videos[0].type === '3d'
                ) {
                    arr.splice(1, 0, ...videos, ...virtuals);
                } else {
                    arr.splice(1, 0, ...virtuals, ...videos);
                }
            } else {
                if (
                    virtuals.length > 0 &&
                    virtuals[0].type !== '3d' &&
                    videos.length > 0 &&
                    videos[0].type === '3d'
                ) {
                    arr.splice(0, 0, ...videos, ...virtuals);
                } else {
                    arr.splice(0, 0, ...virtuals, ...videos);
                }
            }

            this.source.imgs = arr;
        },
        showCurrentTab(tab) {
            return tab.type === 'imgs'
                ? this.allImgs.length
                : this.source[tab.value].length;
        },
        streamToInner(item, index) {
            if (index === this.currentMediaTabIndex) {
                return;
            }
            const { type } = item;
            this.showInner(type, index);
        },
        showInner(type, index) {
            this.removeImgStyle();
            this.swiper && this.swiper.slideTo(index);
        },
        async changeToVideo(item) {
            let { currentMediaTabIndex } = this;
            let virtuals = this.source.virtuals || [];
            const url = item?.url;
            if (url) {
                const res = await API.getCanXFrame.call(this, url);
                if (!res?.data?.canXFrame) {
                    window.open(url, '_blank');
                    return;
                }
            }

            if (item.type !== 'img') {
                if (item.type === '3d') {
                    this.selectedTabIndex =
                        virtuals.length > 0 && virtuals[0].type === '3d'
                            ? currentMediaTabIndex
                            : currentMediaTabIndex + 1;
                } else {
                    let videos = this.source.videos || [];
                    this.selectedTabIndex =
                        videos.length > 0 && videos[0].type === '3d'
                            ? currentMediaTabIndex - 1
                            : virtuals.length > 0
                                ? currentMediaTabIndex
                                : currentMediaTabIndex + 1;
                }
            }
        },
        handleShare() {
            this.$emit('share');
        },
        formatUrl(url) {
            const res = this.parseYoutube(url);
            if (res.overwrite) {
                return res.url;
            } else {
                return url;
            }
        },
        parseYoutube(url) {
            /*https://youtu.be/Ounzu9U8NNc
            https://youtu.be/Ounzu9U8NNc?t=19
            https://www.youtube.com/watch?v=Ounzu9U8NNc
             converted to https://www.youtube.com/embed/Ounzu9U8NNc
            */
            let hash;
            try {
                let regs = [
                    /http?s:\/\/youtu.be\/([^?/]*)/,
                    /http?s:\/\/www.youtube.com\/watch\?v=([^?/]*)/
                ];

                let matches = regs.map(reg => url.match(reg));
                matches = matches.filter(match => match?.length === 2);
                hash = matches[0][1] || '';
            } catch (error) {
                console.log(error);
                return { overwrite: false, url };
            }

            if (!hash) {
                return { overwrite: false, url }; 
            }
            return {
                overwrite: true,
                url: `https://www.youtube.com/embed/${hash}`
            };
        },

        canPlayWithVideo(url) {
            return /^.*.mp4|.webm|.ogg$/i.test(url);
        },
        _openGalleryPop(index = 0, $event, item) {
            if (!(item instanceof Object)) {
                let _index = index;
                let virtuals = this.source.virtuals || [];
                let videos = this.source.videos || [];

                if (
                    (videos.length > 0 && videos[0].type === '3d') ||
                    (virtuals.length > 0 && virtuals[0].type === '3d')
                ) {
                    _index = index - 1 < 0 ? 0 : index - 1;
                }
                item = this.allImgs[_index];
            }
            let newIndex = this.source?.imgs.findIndex(
                k =>
                    k.preview == item.preview &&
                    k.type == item.type &&
                    k.url == item.url
            );
            newIndex = newIndex < 0 ? 0 : newIndex;
            this.currentMediaTabIndex = newIndex;
            this.removeImgStyle();
            setTimeout(() => {
                const galleryPopRef = this.$refs?.galleryPopRef;
                const el = galleryPopRef?.querySelectorAll('.img-box')[index];
                index &&
                    el &&
                    el.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start',
                        inline: 'start'
                    });
                this.swiper && this.swiper.slideTo(newIndex);
            });
        },
        _openVirtualTourPop() {
            this.fingerPs.then(() => {
                this.selectedTabIndex = 1;
            });
        },
        _openVideoPop() {
            this.fingerPs.then(() => {
                this.selectedTabIndex = 2;
            });
        },
        closeInnerPop() {
            this.display(false);
            this.selectedTabIndex = 0;
            this.currentMediaTabIndex = 0;
        },
        removePinchEvent() {
            const Hammer = window?.Hammer;
            Hammer && Hammer.Manager.destroy();
        },
        async handleChangeTabs(item, index) {
            if (index > 0) {
                const url = this.source[item.value][0].url;
                if (url) {
                    const res = await API.getCanXFrame.call(this, url);
                    if (!res?.data?.canXFrame) {
                        window.open(url, '_blank');
                        return;
                    }
                }
            }
            this.selectedTabIndex = index;
            this.currentMediaTabIndex = 0;
            this.removeImgStyle();
        },
        handleReduce() {
            let { scaleValue } = this;
            scaleValue = scaleValue < 10 ? 0 : scaleValue - 10;
            this.scaleValue = scaleValue;
        },
        handleRelarge() {
            let { scaleValue } = this;
            scaleValue = scaleValue > 190 ? 200 : scaleValue + 10;
            this.scaleValue = scaleValue;
        },
        formatTooltip(value) {
            return value + '%';
        },
        removeImgStyle() {
            let oDiv =
                this?.$refs['imgRef' + this.currentMediaTabIndex]?.[0]?.$el;
            oDiv?.removeAttribute('style');
            this.scaleValue = this.defaultScaleValue;
        },
        // img drag
        posMove(ev, type, getdivid) {
            let oDiv = this?.$refs['imgRef' + getdivid]?.[0]?.$el;
            let oParent = this?.$refs['myWriperBoxRef'];
            if (type == 'img') {
                let oEvent = ev || event;
                let sentX = oEvent.clientX - oDiv.offsetLeft;
                let sentY = oEvent.clientY - oDiv.offsetTop;

                document.onmousemove = function(ev) {
                    let oEvent = ev || event;

                    let slideLeft = oEvent.clientX - sentX;
                    let slideTop = oEvent.clientY - sentY;

                    if (
                        oEvent.clientX > oParent.offsetLeft &&
                        oEvent.clientX <
                            oParent.offsetLeft + oParent.offsetWidth
                    ) {
                        oDiv.style.left = slideLeft + 'px';
                    }
                    if (
                        oEvent.clientY > oParent.offsetTop &&
                        oEvent.clientY <
                            oParent.offsetTop + oParent.offsetHeight
                    ) {
                        oDiv.style.top = slideTop + 'px';
                    }
                };
                document.onmouseup = function() {
                    document.onmousemove = null;
                    document.onmouseup = null;
                };
            }

            return false;
        },
        request() {
            signLog.register(
                {
                    registerTitle: null,
                    submitRegister: ''
                },
                'evaluationRegister'
            );
        }
        // onKeyUp(e) {
        //     if (e?.key === 'ArrowRight') {
        //         this.slideNext();
        //     } else if (e?.key === 'ArrowLeft') {
        //         this.slidePrev();
        //     }
        // }
    }
};
</script>

<style lang="scss">
@import '@/theme/mixin.scss';
.comp-gallery-pop {
    width: 100vw;
    height: 100vh;
    background: #fff;
    overflow: hidden;
    .iconfont {
        cursor: pointer;
        &.icon-heart-fill {
            &.active {
                color: #f0454c !important;
            }
        }
    }
    .com-gallery-pop_inner {
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
        .inner-header {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            background: #fff;
            font-size: 16px;
            font-weight: 600;
            color: #8b93a7;
            padding: 0 20px;
            .inner-tab {
                display: flex;
                border-bottom: 1px solid #f1f2f3;

                p {
                    padding: 20px 0;
                    margin-left: 30px;
                    cursor: pointer;
                    &.active {
                        border-bottom: 6px solid var(--mg-button-background);
                    }
                }
            }
            .img-number {
                font-size: 18px;
                > span {
                    color: var(--mg-button-background);
                }
            }
            .inner-status {
                display: flex;
                flex-direction: row;
                align-items: center;
                .pop-icons {
                    font-size: 14px;
                    font-weight: 500;
                    text-align: center;
                    color: #4a4a60;
                    display: flex;
                    flex-direction: column;
                    margin: 0 15px;
                    cursor: pointer;
                    > span {
                        margin-top: 4px;
                    }
                    &:hover {
                        .btn-text {
                            color: #191919;
                        }
                    }
                    &.save {
                        .iconfont {
                            color: #f0454c;
                        }
                        .hover {
                            display: none;
                        }
                        &.active,
                        &:hover {
                            .default {
                                display: none;
                            }
                            .hover {
                                display: block;
                            }
                        }
                    }
                    &.share {
                        position: relative;
                        .iconfont {
                            color: #515666;
                        }
                        .default {
                            display: block;
                        }
                        .hover {
                            display: none;
                        }
                        &:hover {
                            .popper {
                                visibility: visible;
                            }
                            .default {
                                display: none;
                            }
                            .hover {
                                display: block;
                                color: #348cff;
                            }
                        }
                        .popper {
                            position: absolute;
                            top: 100%;
                            left: 50%;
                            padding-top: 15px;
                            z-index: var(--level-medium);
                            transform: translateX(-50%);
                            visibility: hidden;
                        }
                    }
                    &.request {
                        padding: 6px 18px 10px;
                        border-radius: 20px;
                        font-family: var(--font-bold);
                        max-width: 250px;
                        @include ellipsis();
                        @include color-button();
                    }
                }
                .iconfont {
                    font-size: 22px;
                    &.icon-heart {
                        color: #f0454c;
                    }
                    &.icon-close-light {
                        font-size: 22px;
                    }
                    &.active {
                        color: var(--mg-button-background);
                    }
                }
            }
        }

        .inner-content {
            flex: 1;
            display: flex;
            padding: 20px;
            flex-direction: row;
            justify-content: center;
            background: #eeeff5;
            overflow: hidden;
            .img-tabs {
                width: 314px;
                margin-right: 10px;
                padding-right: 5px;
                overflow-y: auto;
                overflow-x: hidden;
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                flex-shrink: 0;
                justify-content: space-between;
                // align-content: start;
                &::-webkit-scrollbar {
                    overflow-y: hidden;
                    width: 4px;
                }
                &::-webkit-scrollbar-thumb {
                    background-color: rgba(32, 36, 5, 0.2);
                    width: 4px;
                    border-radius: 6px;
                }
                &:hover::-webkit-scrollbar {
                    overflow-y: auto;
                }
                .img-box {
                    width: 100%;
                    height: 223px;
                    cursor: pointer;
                    &.img-row-box {
                        width: 49.5%;
                        height: 110px;
                        margin-bottom: 4px;
                    }
                    &.active {
                        border: solid 3px var(--mg-button-background);
                    }
                }

                > div:not(:last-child) {
                    margin-bottom: 10px;
                }
            }
            .content {
                flex: 1;
                overflow: hidden;
                display: flex;
                flex-direction: column;
                .my-swiper-box {
                    flex: 1;
                    overflow: hidden;
                    position: relative;
                    .swiper {
                        height: 100%;
                        object-fit: cover;
                        overflow: hidden;
                        .swiper-button-prev,
                        .swiper-button-next {
                            position: absolute;
                            top: 50%;
                            transform: translateY(-50%);
                            z-index: 1;
                            font-size: 28px;
                            font-weight: blod;
                            height: 100%;
                            width: 100px;
                            color: rgba(255, 255, 255, 0.8);
                            cursor: pointer;
                            margin-top: 0px;
                            &:hover {
                                color: white;
                                &::before {
                                    background: var(--mg-button-background);
                                }
                            }
                            &::before {
                                position: absolute;
                                top: 50%;
                                left: 50%;
                                transform: translate(-50%, -50%);
                                background: rgba(25, 25, 25, 0.4);
                                border-radius: 50%;
                                height: 48px;
                                width: 48px;
                                text-align: center;
                                line-height: 48px;
                            }
                            &::after {
                                display: none;
                            }
                            &.disabled {
                                opacity: 0.35;
                                pointer-events: none;
                            }
                        }
                        .swiper-button-prev {
                            left: 0;
                            background-image: linear-gradient(
                                90deg,
                                rgba(0, 0, 0, 0.6),
                                transparent
                            );
                        }
                        .swiper-button-next {
                            right: 0;
                            &:hover {
                                background-image: linear-gradient(
                                    270deg,
                                    rgba(0, 0, 0, 0.6),
                                    transparent
                                );
                            }
                        }
                        .gallery-img {
                            height: 100%;
                            text-align: center;
                            position: relative;
                            img {
                                height: 100%;
                                object-fit: cover;
                                transition: 0.3 all ease;
                                -webkit-user-drag: none;
                                position: absolute;
                                left: 50%;
                                top: 50%;
                                transform: translate(-50%, -50%);
                            }
                            &.my-virtual-img-box,
                            &.my-3d-img-box {
                                img {
                                    cursor: pointer;
                                }
                            }
                            &.my-video-img-box,
                            &.my-virtual-img-box {
                                img {
                                    cursor: pointer;
                                    filter: brightness(0.6) blur(2px);
                                }
                                .play-icon {
                                    position: absolute;
                                    top: 50%;
                                    left: 50%;
                                    transform: translate(-50%, -50%);
                                    width: 67px;
                                    height: 67px;
                                    border-radius: 50%;
                                    background: #fff;
                                    text-align: center;
                                    line-height: 67px;
                                    .iconfont {
                                        font-size: 24px;
                                        transform: rotate(-90deg);
                                        display: inline-block;
                                        margin-left: 4px;
                                    }
                                }
                            }
                        }
                        .video-content {
                            height: 100%;
                            video {
                                width: 100%;
                                height: 100%;
                            }
                        }
                        .slide-content {
                            overflow: hidden;
                            display: flex;
                            flex-direction: column;
                        }
                    }
                    .rangeBox {
                        position: absolute;
                        z-index: 2;
                        bottom: 10px;
                        left: 50%;
                        transform: translate(-50%);
                        background: rgba(32, 36, 5, 0.3);
                        width: 200px;
                        padding: 0 10px;
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        .mySlider {
                            flex: 1;
                            padding: 0 10px;
                        }
                        > span {
                            cursor: pointer;
                            font-size: 24px;
                            font-weight: bold;
                            color: #fff;
                            margin-top: -5px;
                            user-select: none;
                        }
                        .el-slider__bar {
                            background-color: var(--mg-button-background);
                        }
                        .el-slider__button {
                            border-color: var(--mg-button-background);
                        }
                    }
                }
                .schedule-bth {
                    @include color-button-hover();
                    position: relative;
                    width: 280px;
                    height: 44px;
                    font-size: 16px;
                    color: #fff;
                    margin: 20px auto 0;
                    text-align: center;
                    font-family: var(--font-bold);
                    z-index: 10;
                    @include color-button();
                    &:hover {
                        .banner-schedule {
                            visibility: visible;
                        }
                    }
                    .text {
                        display: inline-block;
                        max-width: 250px;
                        @include ellipsis();
                    }
                    .banner-schedule {
                        visibility: hidden;
                        cursor: initial;
                        padding-top: 10px;
                        width: 350px;
                        position: absolute;
                        bottom: 100%;
                        right: -30px;
                        z-index: 30;
                        font-family: initial;
                        text-align: left;
                        .schedule-top-bar {
                            background-color: var(--mg-button-background);
                        }
                        .tab-item {
                            &.active {
                                color: var(--mg-button-background);
                                border-color: var(--mg-button-background);
                            }
                        }
                        .date-container {
                            .date {
                                .date-day {
                                    color: var(--mg-button-background);
                                }
                                &.selected {
                                    border-color: var(--mg-button-background);
                                    .icon {
                                        background-color: var(
                                            --mg-button-background
                                        );
                                    }
                                }
                            }
                        }
                        .phone {
                            color: var(--mg-button-background);
                        }
                    }
                }
            }
        }
        .mls-info {
            height: 36px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 12px;
            background-color: #fff;
            color: #515666;
            margin-bottom: 10px;
            .mls-info-logo {
                margin-right: 10px;
                height: 20px;
            }
            .mls-info-companyName {
            }
            .mls-info-split {
                height: 8px;
                width: 1px;
                height: 8px;
                margin: 0px 4px;
                background-color: #dadada;
            }
            .mls-info-mlslistingid {
            }
        }
    }
    .video-preview {
        display: flex;
        flex-direction: column;
        justify-content: center;
        position: relative;
        cursor: pointer;
        width: 100%;
        height: 223px;
        &.active {
            border: solid 3px #4c84ff;
        }
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
        .play-icon {
            display: none;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 67px;
            height: 67px;
            border-radius: 50%;
            background: #fff;
            text-align: center;
            line-height: 67px;
            .iconfont {
                font-size: 24px;
                transform: rotate(-90deg);
                display: inline-block;
                margin-left: 4px;
            }
        }
        &.my-video,
        &.my-virtural {
            img {
                filter: brightness(0.6) blur(2px);
            }
            .play-icon {
                display: block;
            }
        }
    }
    &.broker {
        .img-tabs {
            > div {
                border-radius: 5px;
                overflow: hidden;
            }
        }
        .inner-content {
            .content {
                .my-swiper-box {
                    border-radius: 5px;
                }
                .schedule-bth {
                    border-radius: 20px;
                }
            }
        }
    }
    &.classic {
        .img-tabs {
            > div {
                border-radius: 2px;
                overflow: hidden;
            }
        }
        .inner-content {
            .content {
                .my-swiper-box {
                    border-radius: 2px;
                }
                .schedule-bth {
                    border-radius: 2px;
                    .banner-schedule {
                        .tab-item {
                            &.active {
                                color: var(--mg-button-color);
                            }
                        }
                        .date-container {
                            .date {
                                .week {
                                    background-color: var(
                                        --mg-button-background
                                    );
                                }
                                .date-bar {
                                    .asap,
                                    .iconfont {
                                        color: var(--mg-button-background);
                                    }
                                }

                                .selected {
                                    background-color: var(
                                        --mg-button-background
                                    );
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    &.fashion {
        .img-tabs {
            > div {
                overflow: hidden;
            }
        }
        .inner-content {
            .content {
                .banner-schedule {
                    .appointment {
                        background: rgba(14, 18, 34, 0.9);
                        .schedule-banner {
                            background-image: none;
                        }
                    }
                    .tab-item {
                        &.active {
                            color: var(--mg-button-color);
                        }
                    }
                    .date-container {
                        width: 320px;
                        .date {
                            .week,
                            .date-day {
                                color: #fff;
                            }
                        }
                    }
                }
            }
        }
    }
    &.standard {
        .img-tabs {
            > div {
                border-radius: 2px;
                overflow: hidden;
            }
        }
        .inner-content {
            .content {
                .my-swiper-box {
                    border-radius: 2px;
                }
                .schedule-bth {
                    border-radius: 2px;
                    .banner-schedule {
                        .table-schedule {
                            background-color: #fff;
                        }
                        .tab-item {
                            &.active {
                                color: var(--mg-button-background);
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
